import React, { useState } from 'react';
import { CourseFilterGrid } from '../courses/CourseFilterGrid';
import type { CourseFilter } from '../courses/CourseFilterGrid';
import { SectionHeading } from '../ui/SectionHeading';
export function CourseGridSection() {
  const [filter, setFilter] = useState<CourseFilter>('All');
  return <section className="gutter section bg-mist" aria-labelledby="courses-title" data-id="element-145" data-mp="1o4urnxsua2lg">
      <SectionHeading id="courses-title" title="Find Your Course" intro="Concealed carry classes in Las Vegas, defensive handgun and carbine, home defense, women-only, NRA and USCCA." data-id="element-146" data-mp="2ls37pda2mjg2" />
      <div className="mt-10" data-id="element-147" data-mp="2c1ibtxls7t0u">
        <CourseFilterGrid filter={filter} onFilterChange={setFilter} limit={10} data-id="element-148" data-mp="2c0qfulo9vta1" />
      </div>
    </section>;
}